// extracted by mini-css-extract-plugin
export default {"componentHolder":"ShabaModal_componentHolder__ZKtgG","shabaInput":"ShabaModal_shabaInput__UeHYt","Btn":"ShabaModal_Btn__pKrW2"};